import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../../../../firebase/AuthProvider";
import {
    approveRejectLeave,
    getTimeOffsForManager,
    getRequestHistory,
    getTimeOffById,
} from "../../../../services/userServices/UserInfoService";
import Loader from "../../loader/Loader";
import Swal from "sweetalert2";
import rejectbtnicon from "../../../../assets/images/rejectbtnicon.svg";
import approvebtnicon from "../../../../assets/images/approvebtnicon.svg";
import viewdropdownicon from "../../../../assets/images/viewdropdownicon.svg";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Nav, Tab } from "react-bootstrap";
import { approveRejectRequest } from "../../../../services/participantServices/ParticipantService";
import { showConfirmationDialog } from "../../../modal/ConfimationModal/Confimation";
import { ManagerRequest, RequestHistoryItem } from "../../../../interfaces/UserInfo";
import { PaginationDto } from "../../../../interfaces/Employee/Employee";
import DateRangePicker from "../../signature/DateRangePicker";
import styles from "./AdminRequestsPanel.module.css";
import paginationarrowleft from "../../../../assets/images/paginationarrowleft.svg";
import paginationarrowright from "../../../../assets/images/paginationarrowright.svg";
import AdminRequestModal from "./AdminRequestModal";
import NewAdminRequestModal from "../../adminRequestsTab/NewAdminRequestModal";
import RequestTaskClosureModal from "../../taskPage/Modals/RequestTaskClosureModal";
import RequestTaskExtensionModal from "../../taskPage/Modals/RequestTaskExtensionModal";
import {
    approveAdministrativeTransactionRequest,
    rejectAdministrativeTransactionRequest
} from "../../../../services/AdministrativeRequestServices/AdministrativeRequestService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { AppEvents } from "../../../../events/events";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const AdminRequestsPanel = () => {

    const navigate = useNavigate();

    const [requests, setRequests] = useState<ManagerRequest[]>([]);
    const [requestHistoryItems, setRequestHistoryItems] = useState<RequestHistoryItem[]>([]);
    const [requestCount, setRequestCount] = useState<number>(0);
    const [pendingInboxCount, setPendingInboxCount] = useState<number>(0);
    const [error, setError] = useState<string | null>(null);
    const [processingAction, setProcessingAction] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);
    const { currentUser, currentRoles, currentOrganization } = useAuth();
    const userId = (currentUser as any)?.uid;
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [rejectionReason, setRejectionReason] = useState("");
    const [show, setShow] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState<any>(null);
    const [activeTab, setActiveTab] = useState<"inbox" | "sent">("inbox");
    const [statusFilter, setStatusFilter] = useState<string>("All Status");
    const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const statusDropdownRef = useRef<HTMLDivElement>(null);
    const activeTabRef = useRef(activeTab);

    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 5 });
    const [showNewRequestModal, setShowNewRequestModal] = useState(false);
    const [showTaskClosureModal, setShowTaskClosureModal] = useState(false);
    const [showTaskExtensionModal, setShowTaskExtensionModal] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null);
    
    useEffect(() => {
        activeTabRef.current = activeTab;
    }, [activeTab]);

    const handleClose = () => setShow(false);
    const handleTabSelect = (selectedKey: any) => {
        setPagination({ pageNumber: 1, pageSize: pagination.pageSize })
        setRequests([]);
        setRequestHistoryItems([]);
        setRequestCount(0);
        setActiveTab(selectedKey);
    };

    const statusOptions = ["All Status", "Pending", "Approved", "Rejected", "Expired"];

    const handleStatusFilterChange = (status: string) => {
        setStatusFilter(status);
        setStatusDropdownOpen(false);
        setPagination({ pageNumber: 1, pageSize: pagination.pageSize });
    };

    const handleDateRangeChange = (start: Date | null, end: Date | null) => {
        setStartDate(start);
        setEndDate(end);
        setPagination({ pageNumber: 1, pageSize: pagination.pageSize });
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target as Node)) {
                setStatusDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleApprove = async (id: number) => {
        if (!currentUser) return;

        try {
            setLoading(true);
            setProcessingAction('approve_timeoff');
            const token = await currentUser.getIdToken();
            const res = await approveRejectLeave(id, "approve", "", token);
            if (res.success) {
                toast.success(res.message);
                fetchData();
                fetchPendingInboxCount();
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
            } else {
                toast.error(res.message);
            }
        } catch (error: any) {
            toast.error(error.message || "Internal Server Error");
        } finally {
            setLoading(false);
            setProcessingAction(null);
        }

    };

    const handleRejectClick = (id: number) => {
        setSelectedId(id);
        setShow(true)
    };

    const handleProfileApprove = async (request: any) => {
        const isConfirmed = await showConfirmationDialog(
            "Are you sure?",
            "You are about to approve this request."
        );
        if (!isConfirmed) return;
        if (!currentUser) return;
        setLoading(true);
        setProcessingAction('approve_profile');

        try {

            const token = await currentUser.getIdToken();
            const requestId = request.transationRequestId;

            const success = await approveRejectRequest(
                requestId,
                {
                    action: "approve",
                    reason: "",
                    id: request.id,
                    participantId: request.participantId,
                    firstName: request.newProfileChanegs.firstName,
                    lastName: request.newProfileChanegs.lastName,
                    email: request.newProfileChanegs.email,
                    mobileNumber: request.newProfileChanegs.mobileNumber,
                    countryName: request.newProfileChanegs.countryName,
                    waiverId: request.newProfileChanegs.waiverId,
                    countryId: request.newProfileChanegs.countryId,
                    regionId: request.newProfileChanegs.regionId,
                },
                token
            );

            if (success) {
                Swal.fire("Approved!", "The request has been approved.", "success");
                setViewModalOpen(false);
                fetchData();
                fetchPendingInboxCount();
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
            } else {
                Swal.fire("Error", "Failed to approve request.", "error");
            }
        }
        finally {
            setLoading(false);
            setProcessingAction(null); // Reset action
        }
    };

    const handleProfileRejectConfirm = (request: any) => {
        (async () => {
            const isConfirmed = await showConfirmationDialog(
                "Are you sure?",
                "You are about to reject this request."
            );
            if (isConfirmed) {
                handleProfileReject(request);
            }
        })();
    };

    const handleProfileReject = async (request: any) => {
        if (!currentUser) return;
        setLoading(true);
        setProcessingAction('reject_profile');

        try {

            const token = await currentUser.getIdToken();
            const requestId = request.transationRequestId

            const success = await approveRejectRequest(
                requestId,
                {
                    action: "reject",
                    reason: rejectionReason,
                    id: request.id,
                    participantId: request.participantId,
                    firstName: request.newProfileChanegs.firstName,
                    lastName: request.newProfileChanegs.lastName,
                    email: request.newProfileChanegs.email,
                    mobileNumber: request.newProfileChanegs.mobileNumber,
                    countryName: request.newProfileChanegs.countryName,
                    waiverId: request.newProfileChanegs.waiverId,
                    countryId: request.newProfileChanegs.countryId,
                    regionId: request.newProfileChanegs.regionId,
                },
                token
            );

            if (success) {
                toast.success(success.message);
                setViewModalOpen(false);
                fetchData();
                fetchPendingInboxCount();
                setRejectionReason("");
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
            } else {
                alert("Failed to approve request.");
            }
        }
        finally {
            setLoading(false);
            setProcessingAction(null);
        }
    };

    const handleRejectConfirm = async () => {
        if (!currentUser) return;
        setLoading(true);
        setProcessingAction('reject_confirm');

        try {
            const token = await currentUser.getIdToken();
            if (selectedId !== null) {
                const res = await approveRejectLeave(selectedId, "reject", rejectionReason, token);
                if (res.success) {
                    toast.success("Leave request rejected successfully");
                    setLoading(false);
                    fetchData();
                    fetchPendingInboxCount();
                    AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
                } else {
                    toast.error(res.message);
                }

            }
            setRejectionReason("");
            setSelectedId(null);
            setShow(false)
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setLoading(false);
            setProcessingAction(null);
        }
    };

    const handleViewClick = (req: any) => {
        setSelectedRequest(req);
        setViewModalOpen(true);
    };

    const handleViewClose = () => {
        setViewModalOpen(false);
    };

    const fetchData = async () => {
        if (!currentUser) return;

        setFetchLoading(true);
        try {
            const token = await currentUser.getIdToken();

            // Format dates for API (only if both are selected)
            // Use local date format (YYYY-MM-DD) to avoid timezone issues
            const formatDateForAPI = (date: Date): string => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const formattedStartDate = startDate && endDate ? formatDateForAPI(startDate) : undefined;
            const formattedEndDate = startDate && endDate ? formatDateForAPI(endDate) : undefined;

            if (activeTab === "sent") {
                // Call the new request history API for "Sent" tab
                setRequestHistoryItems([]);
                const result = await getRequestHistory(
                    token,
                    pagination.pageNumber,
                    pagination.pageSize,
                    statusFilter,
                    formattedStartDate,
                    formattedEndDate
                );

                if (result.success) {
                    setRequestHistoryItems(result.data.items);
                    setRequestCount(result.data.totalCount ?? 0);
                } else {
                    setRequestHistoryItems([]);
                    setRequestCount(0);
                }
            } else {
                // Call the existing API for "Inbox" tab
                const transactionalTypeName = "";
                setRequests([]);
                const result = await getTimeOffsForManager(
                    userId,
                    token,
                    transactionalTypeName,
                    pagination.pageNumber,
                    pagination.pageSize,
                    statusFilter,
                    formattedStartDate,
                    formattedEndDate
                );

                if (result.success) {
                    setRequests(result.data.items);
                    setRequestCount(result.data.totalCount ?? 0);
                } else {
                    setRequests([]);
                    setRequestCount(0);
                }
            }
        } catch (err: any) {
            setError("Something went wrong.");
            setRequests([]);
            setRequestHistoryItems([]);
            setRequestCount(0);
        } finally {
            setFetchLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [userId, currentUser, activeTab, pagination, statusFilter, startDate, endDate]);

    // Fetch pending inbox count
    const fetchPendingInboxCount = async () => {
        if (!currentUser || !userId) return;

        try {
            const token = await currentUser.getIdToken();
            const transactionalTypeName = "";
            const result = await getTimeOffsForManager(
                userId,
                token,
                transactionalTypeName,
                1, // pageNumber
                1, // pageSize - minimal to just get the count
                "Pending", // status filter for pending only
                undefined, // startDate
                undefined // endDate
            );

            if (result.success && result.data) {
                setPendingInboxCount(result.data.totalCount || 0);
            } else {
                setPendingInboxCount(0);
            }
        } catch (err: any) {
            console.error("Error fetching pending inbox count:", err);
            setPendingInboxCount(0);
        }
    };

    useEffect(() => {
        fetchPendingInboxCount();
    }, [userId, currentUser]);

    const handleAdminRequestApprove = async (requestId: number) => {
        const isConfirmed = await showConfirmationDialog(
            "Are you sure?",
            "You are about to approve this request."
        );
        if (!isConfirmed) return;
        if (!currentUser) return;
        setLoading(true);
        setProcessingAction('approve_admin');

        try {
            const token = await currentUser.getIdToken();
            const result = await approveAdministrativeTransactionRequest(token, requestId);

            if (result.success) {
                toast.success("Request approved successfully");
                setViewModalOpen(false);
                fetchData();
                fetchPendingInboxCount();
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
            } else {
                toast.error(result.message || "Failed to approve request");
            }
        } catch (error: any) {
            toast.error(error.message || "Failed to approve request");
        } finally {
            setLoading(false);
            setProcessingAction(null);
        }
    };

    const handleAdminRequestReject = async (requestId: number) => {
        const isConfirmed = await showConfirmationDialog(
            "Are you sure?",
            "You are about to reject this request."
        );
        if (!isConfirmed) return;
        if (!currentUser) return;
        setLoading(true);
        setProcessingAction('reject_admin');

        try {
            const token = await currentUser.getIdToken();
            const result = await rejectAdministrativeTransactionRequest(token, requestId);

            if (result.success) {
                toast.success("Request rejected successfully");
                setViewModalOpen(false);
                fetchData();
                fetchPendingInboxCount();
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
            } else {
                toast.error(result.message || "Failed to reject request");
            }
        } catch (error: any) {
            toast.error(error.message || "Failed to reject request");
        } finally {
            setLoading(false);
            setProcessingAction(null);
        }
    };

    if (error) return <p>Error: {error}</p>;

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(e.target.value);
        setPagination({
            pageNumber: 1,
            pageSize: newPageSize
        });
    }

    const handlePreviousPage = () => {
        if (pagination.pageNumber > 1) {
            setPagination((prev) => ({
                ...prev,
                pageNumber: prev.pageNumber - 1
            }));
        }
    }

    const handleNextPage = () => {
        const totalPages = requestCount ? Math.ceil(requestCount / pagination.pageSize) : 1;
        if (pagination.pageNumber < totalPages) {
            setPagination((prev) => ({
                ...prev,
                pageNumber: prev.pageNumber + 1
            }));
        }
    }

    // const formatDate = (dateString: string) => {
    //     const date = new Date(dateString);
    //     const months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", 
    //                    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
    //     return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    // }

    // Helper functions for "sent" tab cards
    const getSentTabRequestTitle = (req: RequestHistoryItem) => {
        if (req.historyType === "leave") {
            const startDate = req.timeOffDetails?.timeOffStartDate;
            const endDate = req.timeOffDetails?.timeOffEndDate;

            if (startDate && endDate) {
                const formattedStartDate = new Date(startDate).toLocaleDateString();
                const formattedEndDate = new Date(endDate).toLocaleDateString();
                return `Leave Request (${formattedStartDate} - ${formattedEndDate})`;
            }
            return "Leave Request";
        } else {
            return `${req.requesterName || ""} - Admin Request`;
        }
    }

    const getSentTabRequestSubtitle = (req: RequestHistoryItem) => {
        if (req.historyType === "leave") {
            return req.timeOffDetails?.typeOfLeave || "";
        } else {
            return req.transactionType || "";
        }
    }

    const getRequestTitle = (req: ManagerRequest | RequestHistoryItem) => {
        if ('historyType' in req) {
            const historyItem = req as RequestHistoryItem;
            if (historyItem.historyType === "leave") {
                return "Time Off Request";
            } else {
                return historyItem.taskTitle || `${historyItem.requesterName || ""} - ${historyItem.transactionType || "Request"}`;
            }
        } else {
            const managerReq = req as ManagerRequest;
            if (managerReq.timeOffDetails) {
                return `${managerReq.requesterName} - Time Off Request`;
            } else if (managerReq.participantRequest) {
                return `${managerReq.requesterName} - Profile Change Request`;
            } else {
                return managerReq.taskTitle || `${managerReq.requesterName} - ${managerReq.transactionType}`;
            }
        }
    }

    const getRequestSubtitle = (req: ManagerRequest | RequestHistoryItem) => {
        if ('historyType' in req) {
            const historyItem = req as RequestHistoryItem;
            if (historyItem.historyType === "leave" && historyItem.timeOffDetails) {
                return `Time Off Request - ${historyItem.timeOffDetails.typeOfLeave}`;
            } else {
                return historyItem.transactionType || "Other Request";
            }
        } else {
            const managerReq = req as ManagerRequest;
            if (managerReq.timeOffDetails) {
                return `Time Off Request - ${managerReq.timeOffDetails.typeOfLeave}`;
            } else if (managerReq.participantRequest) {
                return "Profile Change Request";
            } else {
                return managerReq.transactionType || "Other Request";
            }
        }
    }

    const getStatusBadgeClass = (status: string) => {
        const statusLower = status?.toLowerCase() || "";
        if (statusLower === "pending") return styles.statusBadgePending;
        if (statusLower === "approved") return styles.statusBadgeApproved;
        if (statusLower === "rejected") return styles.statusBadgeRejected;
        if (statusLower === "expired") return styles.statusBadgeExpired;
        return styles.statusBadgePending;
    }

    const handleCardClick = (req: ManagerRequest | RequestHistoryItem) => {
        // Check if it's a RequestHistoryItem
        if ('historyType' in req) {
            const historyItem = req as RequestHistoryItem;
            if (historyItem.historyType === "leave") {
                setSelectedRequest({ ...historyItem, type: 'requestHistoryLeave' });
                setViewModalOpen(true);
            } else if (historyItem.historyType === "admin") {
                setSelectedRequest({ ...historyItem, type: 'requestHistoryAdmin' });
                setViewModalOpen(true);
            }
        } else {
            const managerReq = req as ManagerRequest;
            console.log('Clicked Request', req)
            if (managerReq.participantRequest) {
                handleViewClick({ ...managerReq.participantRequest, requestTime: managerReq.requestTime });
            } else if (managerReq.timeOffDetails) {
                // For time off requests, show details and allow approve/reject
                setSelectedRequest({ ...managerReq, type: 'timeOff' });
                setViewModalOpen(true);
            } else if (managerReq.taskFriendlyId) {
                // Show modal for admin requests with task details
                setSelectedRequest({ ...managerReq, type: 'adminTaskRequest' });
                setViewModalOpen(true);
            }
        }
    }

    const handleCancelRequest = async (request: RequestHistoryItem) => {
        const confirmed = await showConfirmationDialog(
            "Are you sure?",
            "You are about to cancel this request."
        );
        if (!confirmed) return;

        if (!currentUser) return;
        setLoading(true);
        setProcessingAction('cancel');

        try {
            const token = await currentUser.getIdToken();
            // Use employeeTimeOffId if available, otherwise fallback to timeOffDetails.id
            const timeOffId = request.employeeTimeOffId || request.timeOffDetails?.id;
            if (!timeOffId) {
                toast.error("Unable to cancel request: Time off ID not found");
                return;
            }

            const response = await getTimeOffById(timeOffId, token);

            if ("error" in response) {
                toast.error(response.error);
            } else {
                toast.success(response.message || "Request cancelled successfully");
                fetchData();
            }
        } catch (err: any) {
            toast.error("Failed to cancel request. Please try again.");
            console.error("Error cancelling request:", err);
        } finally {
            setLoading(false);
            setProcessingAction(null);
        }
    };

    const handleNewRequest = () => {
        setShowNewRequestModal(true);
    }

    const handleCloseNewRequestModal = () => {
        setShowNewRequestModal(false);
        fetchData(); // Refresh the list after closing
        fetchPendingInboxCount(); // Refresh pending count
    }

    // Handle task selection from AdminRequestModal
    const handleTaskSelected = (taskId: string, requestType: string) => {
        if (isNaN(Number(taskId))) {
            toast.error("Invalid task ID");
            return;
        }

        setSelectedTaskId(Number(taskId));
        setShowNewRequestModal(false); // Close AdminRequestModal

        // Open appropriate modal based on request type
        if (requestType === "task-deletion-request") {
            setShowTaskClosureModal(true);
        } else if (requestType === "task-extension-request") {
            setShowTaskExtensionModal(true);
        }
    }

    const handleCloseTaskClosureModal = () => {
        setShowTaskClosureModal(false);
        setSelectedTaskId(null);
        fetchData(); // Refresh the list after closing
        fetchPendingInboxCount(); // Refresh pending count
    }

    const handleCloseTaskExtensionModal = () => {
        setShowTaskExtensionModal(false);
        setSelectedTaskId(null);
        fetchData(); // Refresh the list after closing
        fetchPendingInboxCount(); // Refresh pending count
    }

    return (
        <>
            {loading && <Loader />}
            <div className={styles.container}>
                {/* Header with Tabs and Filters */}
                <div className={styles.header}>
                    {/* Left Tabs */}
                    <Tab.Container id="inbox-sent-tabs" activeKey={activeTab} onSelect={handleTabSelect}>
                        <div className={`tab_flx ${styles['tab-items-test']}`}>
                            <Nav variant="pills" className="common_tab bg-[#F9F6FF]">
                                <Nav.Item>
                                    <Nav.Link eventKey="inbox" className="w-[150px]">
                                        Inbox
                                        {pendingInboxCount > 0 && (
                                            <span className="ms-2 px-2 py-0.5 bg-[#7E57C2] text-white text-xs font-semibold rounded-full">
                                                {pendingInboxCount}
                                            </span>
                                        )}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="sent" className="w-[150px]">Sent</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                    </Tab.Container>

                    {/* Right Filters */}
                    <div className={styles.filtersContainer}>
                        <div className={styles.dateRangePickerWrapper}>
                            <DateRangePicker
                                onDateRangeChange={handleDateRangeChange}
                                initialStartDate={startDate}
                                initialEndDate={endDate}
                                showDefaultDates={false}
                            />
                        </div>

                        {
                            activeTab == "sent" &&
                            (
                                <div className={styles.statusDropdown} ref={statusDropdownRef}>
                                    <button
                                        className={styles.statusDropdownButton}
                                        onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}
                                    >
                                        <span>{statusFilter}</span>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor">
                                            <path d="M3 4.5L6 7.5L9 4.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                    {statusDropdownOpen && (
                                        <div className={styles.statusDropdownMenu}>
                                            {statusOptions.map((option) => (
                                                <div
                                                    key={option}
                                                    className={`${styles.statusDropdownItem} ${statusFilter === option ? styles.statusDropdownItemActive : ""
                                                        }`}
                                                    onClick={() => handleStatusFilterChange(option)}
                                                >
                                                    {option}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )
                        }



                        <button className={styles.newRequestButton} onClick={handleNewRequest}>
                            + New Request
                        </button>
                    </div>
                </div>

                {/* Main Content - Request Cards */}
                <div className={styles.requestsList}>
                    {fetchLoading ? (
                        <div className={styles.loadingState}>
                            <Spinner animation="border" size="sm" role="status" className="me-2" />
                            Loading...
                        </div>
                    ) : (activeTab === "sent" ? requestHistoryItems.length === 0 : requests.length === 0) ? (
                        <div className={styles.emptyState}>
                            No requests found.
                        </div>
                    ) : (
                        <>
                            {activeTab === "sent" ? (
                                requestHistoryItems.map((req) => (
                                    <div
                                        key={req.id}
                                        className={styles.requestCard}
                                        onClick={() => handleCardClick(req)}
                                    >
                                        <div className={styles.requestCardContent}>
                                            <div className={styles.requestDate}>
                                                {moment(req.requestTime).format("MMMM DD, YYYY").toUpperCase()}
                                            </div>
                                            <h3 className={styles.requestTitle}>
                                                {getSentTabRequestTitle(req)}
                                            </h3>
                                            <p className={styles.requestSubtitle}>
                                                {getSentTabRequestSubtitle(req)}
                                            </p>
                                        </div>
                                        <div className={styles.requestRightSection}>
                                            <span className={`${styles.statusBadge} text-xs ${getStatusBadgeClass(req.status)}`}>
                                                {req.status || "Pending"}
                                            </span>
                                            <button
                                                className={styles.viewButton}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (req.historyType === "leave") {
                                                        setSelectedRequest({ ...req, type: 'requestHistoryLeave' });
                                                        setViewModalOpen(true);
                                                    } else if (req.historyType === "admin") {
                                                        setSelectedRequest({ ...req, type: 'requestHistoryAdmin' });
                                                        setViewModalOpen(true);
                                                    }
                                                }}
                                            >
                                                View
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                requests.map((req) => (
                                    <div
                                        key={req.id}
                                        className={styles.requestCard}
                                        onClick={() => handleCardClick(req)}
                                    >
                                        <div className={styles.requestCardContent}>
                                            <div className={styles.requestDate}>
                                                {moment(req.requestTime).format("MMMM DD, YYYY").toUpperCase()}
                                            </div>
                                            <h3 className={styles.requestTitle}>
                                                {getRequestTitle(req)}
                                            </h3>
                                            <p className={styles.requestSubtitle}>
                                                {getRequestSubtitle(req)}
                                            </p>
                                        </div>
                                        <div className={styles.requestRightSection}>
                                            <span className={`${styles.statusBadge} ${getStatusBadgeClass(req.status)}`}>
                                                {req.status || "Pending"}
                                            </span>
                                            <button
                                                className={styles.viewButton}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (req.participantRequest) {
                                                        handleViewClick({ ...req.participantRequest, requestTime: req.requestTime });
                                                    } else if (req.timeOffDetails) {
                                                        // For time off requests, show details and allow approve/reject
                                                        setSelectedRequest({ ...req, type: 'timeOff' });
                                                        setViewModalOpen(true);
                                                    } else if (req.taskFriendlyId) {
                                                        // Show modal for admin requests with task details
                                                        setSelectedRequest({ ...req, type: 'adminTaskRequest' });
                                                        setViewModalOpen(true);
                                                    }
                                                }}
                                            >
                                                View
                                            </button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </>
                    )}
                </div>

                {/* Pagination */}
                {requestCount > 0 && (activeTab === "sent" ? requestHistoryItems.length > 0 : requests.length > 0) && (
                    <div className={styles.paginationContainer}>
                        <div className={styles.entriesDropdown}>
                            <span className={styles.entriesDropdownLabel}>Show</span>
                            <select
                                className={styles.entriesDropdownSelect}
                                value={pagination.pageSize}
                                onChange={handlePageSizeChange}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span className={styles.entriesDropdownLabel}>Entries</span>
                        </div>
                        <div className={styles.pageNavigation}>
                            <button
                                className={styles.pageButton}
                                onClick={handlePreviousPage}
                                disabled={pagination.pageNumber === 1}
                            >
                                <img src={paginationarrowleft} alt="Previous" className={styles.arrowIcon} />
                            </button>
                            <span className={styles.pageInfo}>
                                Page: {String(pagination.pageNumber).padStart(2, "0")} of {String(Math.max(1, Math.ceil(requestCount / pagination.pageSize))).padStart(2, "0")}
                            </span>
                            <button
                                className={styles.pageButton}
                                onClick={handleNextPage}
                                disabled={pagination.pageNumber >= Math.ceil(requestCount / pagination.pageSize)}
                            >
                                <img src={paginationarrowright} alt="Next" className={styles.arrowIcon} />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Rejection Modal */}
            <Modal show={show} onHide={handleClose} centered className="custom_popup">
                <Modal.Header closeButton>
                    <Modal.Title>Rejection Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group
                        className="flex flex-col w-full"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Control
                            as="textarea"
                            rows={3}
                            className="w-full p-2 border rounded-md"
                            placeholder="Enter reason for rejection..."
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                        />
                    </Form.Group>
                    <div className="mt-3 flex justify-end gap-2">
                        <Button variant="secondary" onClick={handleClose} disabled={loading}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleRejectConfirm}
                            disabled={loading} // Disable while loading
                        >
                            {processingAction === 'reject_confirm' ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                    Saving...
                                </>
                            ) : "Save"}
                        </Button>
                    </div>
                </Modal.Body>

            </Modal>

            {/* View Details Modal */}
            <Modal
                show={viewModalOpen}
                onHide={handleViewClose}
                onExited={() => setSelectedRequest(null)}
                centered
                className={`custom_popup ${styles.viewDetailsModal}`}
            >
                <Modal.Header>
                    <Modal.Title>
                        {selectedRequest?.type === 'timeOff' || selectedRequest?.type === 'requestHistoryLeave'
                            ? 'Time Off Request Details'
                            : selectedRequest?.type === 'requestHistoryAdmin'
                                ? 'Admin Request Details'
                                : selectedRequest?.type === 'adminTaskRequest'
                                    ? 'Admin Request Details'
                                    : 'Participant Request Details'}
                    </Modal.Title>
                    <button
                        className="modal-activity-reject-close rounded-[0.125rem] opacity-[0.7] w-[1rem] h-[1rem]"
                        onClick={handleViewClose}
                    >
                        <FontAwesomeIcon icon={faTimes} className="w-[1rem] h-[1rem]" />
                    </button>
                </Modal.Header>

                <Modal.Body>
                    {selectedRequest && (
                        <div>
                            {selectedRequest.type === 'requestHistoryLeave' ? (
                                // Request History Leave Details
                                <>
                                    <p><strong>Start Date:</strong> {selectedRequest.timeOffDetails?.timeOffStartDate && new Date(selectedRequest.timeOffDetails.timeOffStartDate).toLocaleDateString()}</p>
                                    <p><strong>End Date:</strong> {selectedRequest.timeOffDetails?.timeOffEndDate && new Date(selectedRequest.timeOffDetails.timeOffEndDate).toLocaleDateString()}</p>
                                    <p><strong>Type of Leave:</strong> {selectedRequest.timeOffDetails?.typeOfLeave}</p>
                                    <p><strong>Comment:</strong> {selectedRequest.timeOffDetails?.comment || "-"}</p>
                                    <p><strong>Status:</strong> {selectedRequest.status}</p>
                                    {selectedRequest.status.toLowerCase() === "approved" && <p><strong>Approved By:</strong> {selectedRequest.approverName}</p>}
                                    <p><strong>Requested On:</strong> {new Date(selectedRequest.requestTime).toLocaleDateString()}</p>
                                </>
                            ) : selectedRequest.type === 'requestHistoryAdmin' ? (
                                // Request History Admin Details
                                <>
                                    <p><strong>Requester:</strong> {selectedRequest.requesterName}</p>
                                    <p><strong>Transaction Type:</strong> {selectedRequest.transactionType}</p>
                                    <p><strong>Status:</strong> {selectedRequest.status}</p>
                                    {selectedRequest.taskTitle && (
                                        <div className={styles.taskRow} title={`[${currentOrganization?.abbreviation}-${selectedRequest.taskFriendlyId}] ${selectedRequest.taskTitle}`}>
                                            <strong className={styles.taskLabel}>Task:</strong>
                                            <p
                                                className={styles.taskLink}
                                                onClick={() => navigate(`/task/${currentOrganization?.abbreviation}-${selectedRequest.taskFriendlyId}`)}
                                            >
                                                [{currentOrganization?.abbreviation}-{selectedRequest.taskFriendlyId}] {selectedRequest.taskTitle}
                                            </p>
                                        </div>
                                    )}
                                    {selectedRequest.transactionReasonText && (
                                        <p><strong>Reason:</strong> {selectedRequest.transactionReasonText}</p>
                                    )}
                                    <p><strong>Requested On:</strong> {new Date(selectedRequest.requestTime).toLocaleDateString()}</p>
                                </>
                            ) : selectedRequest.type === 'timeOff' ? (
                                // Time Off Request Details
                                <>
                                    <p><strong>Employee:</strong> {selectedRequest.requesterName}</p>
                                    <p><strong>Start Date:</strong> {selectedRequest.timeOffDetails?.timeOffStartDate && new Date(selectedRequest.timeOffDetails.timeOffStartDate).toLocaleDateString()}</p>
                                    <p><strong>End Date:</strong> {selectedRequest.timeOffDetails?.timeOffEndDate && new Date(selectedRequest.timeOffDetails.timeOffEndDate).toLocaleDateString()}</p>
                                    <p><strong>Type of Leave:</strong> {selectedRequest.timeOffDetails?.typeOfLeave}</p>
                                    <p><strong>Comment:</strong> {selectedRequest.timeOffDetails?.comment || "-"}</p>
                                    <p><strong>Requested On:</strong> {new Date(selectedRequest.requestTime).toLocaleString()}</p>
                                </>
                            ) : selectedRequest.type === 'adminTaskRequest' ? (
                                // Admin Task Request Details
                                <>
                                    <p><strong>Requester:</strong> {selectedRequest.requesterName}</p>
                                    <p><strong>Transaction Type:</strong> {selectedRequest.transactionType}</p>
                                    {selectedRequest.taskTitle && (
                                        <div className={styles.taskRow} title={`[${currentOrganization?.abbreviation}-${selectedRequest.taskFriendlyId}] ${selectedRequest.taskTitle}`}>
                                            <p><strong className={styles.taskLabel}>Task:</strong></p>
                                            <p
                                                className={styles.taskLink}
                                                onClick={() => navigate(`/task/${currentOrganization?.abbreviation}-${selectedRequest.taskFriendlyId}`)}
                                            >
                                                [{currentOrganization?.abbreviation}-{selectedRequest.taskFriendlyId}] {selectedRequest.taskTitle}
                                            </p>
                                        </div>
                                    )}                                    {/* {selectedRequest.taskFriendlyId && currentOrganization && (
                                        <p onClick={() => navigate(`/task/${currentOrganization?.abbreviation}-${selectedRequest.taskFriendlyId}`)}><strong>Task ID:</strong> {currentOrganization.abbreviation}-{selectedRequest.taskFriendlyId}</p>
                                    )} */}
                                    {selectedRequest.transactionReasonText && (
                                        <p><strong>Reason:</strong> {selectedRequest.transactionReasonText}</p>
                                    )}
                                    <p><strong>Status:</strong> {selectedRequest.status}</p>
                                    <p><strong>Requested On:</strong> {new Date(selectedRequest.requestTime).toLocaleDateString()}</p>
                                </>
                            ) : (
                                // Profile Change Request Details
                                <>
                                    {/* Legend */}
                                    <div className="mb-3 d-flex align-items-center gap-4">
                                        <div className="d-flex align-items-center">
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "red",
                                                    marginRight: "6px"
                                                }}
                                            ></span>
                                            <span>Old Value</span>
                                        </div>

                                        <div className="d-flex align-items-center">
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "green",
                                                    marginRight: "6px"
                                                }}
                                            ></span>
                                            <span>Updated Value</span>
                                        </div>
                                    </div>

                                    {/* Dynamic Field Rendering Logic */}
                                    {(() => {
                                        // Helper: Format Dates
                                        const formatDate = (dateStr: string | null | undefined) => {
                                            if (!dateStr) return null;
                                            return new Date(dateStr).toLocaleDateString();
                                        };

                                        // Helper: Handle Empty Display
                                        const formatValue = (val: any) => {
                                            if (val === null || val === undefined || val === "") return <i className="text-muted">(empty)</i>;
                                            return val;
                                        };

                                        // Helper: Compare Values (Robust against null vs empty string)
                                        const hasChanged = (oldVal: any, newVal: any) => {
                                            const o = (oldVal === null || oldVal === undefined) ? "" : String(oldVal).trim();
                                            const n = (newVal === null || newVal === undefined) ? "" : String(newVal).trim();
                                            return o !== n;
                                        };

                                        // 1. Mandatory Fields (Always Shown)
                                        const mandatoryFields = [
                                            {
                                                label: "Name",
                                                oldValue: `${selectedRequest.orignalProfile.firstName} ${selectedRequest.orignalProfile.lastName}`,
                                                newValue: `${selectedRequest.newProfileChanegs.firstName} ${selectedRequest.newProfileChanegs.lastName}`
                                            },
                                            {
                                                label: "Waiver",
                                                oldValue: selectedRequest.orignalProfile.waiverName,
                                                newValue: selectedRequest.newProfileChanegs.waiverName
                                            }
                                        ];

                                        // 2. Conditional Fields (Only Shown if Changed)
                                        const conditionalFields = [
                                            { label: "Email", oldValue: selectedRequest.orignalProfile.email, newValue: selectedRequest.newProfileChanegs.email },
                                            { label: "Mobile Number", oldValue: selectedRequest.orignalProfile.mobileNumber, newValue: selectedRequest.newProfileChanegs.mobileNumber },
                                            { label: "Country", oldValue: selectedRequest.orignalProfile.countryName, newValue: selectedRequest.newProfileChanegs.countryName },
                                            { label: "Linkage Date", oldValue: formatDate(selectedRequest.orignalProfile.linkageDate), newValue: formatDate(selectedRequest.newProfileChanegs.linkageDate) },
                                            { label: "Certification Date", oldValue: formatDate(selectedRequest.orignalProfile.certificationDate), newValue: formatDate(selectedRequest.newProfileChanegs.certificationDate) },
                                            { label: "CPOC Date", oldValue: formatDate(selectedRequest.orignalProfile.cpocDate), newValue: formatDate(selectedRequest.newProfileChanegs.cpocDate) },
                                            { label: "CPOC End Date", oldValue: formatDate(selectedRequest.orignalProfile.cpocEndDate), newValue: formatDate(selectedRequest.newProfileChanegs.cpocEndDate) },
                                        ];

                                        // Filter conditional fields to only those that changed
                                        const changedFields = conditionalFields.filter(f => hasChanged(f.oldValue, f.newValue));

                                        // Combine for rendering
                                        const fieldsToRender = [...mandatoryFields, ...changedFields];

                                        return fieldsToRender.map((f, i) => {
                                            const changed = hasChanged(f.oldValue, f.newValue);
                                            return (
                                                <p key={i} className="mb-2">
                                                    <strong>{f.label}:</strong>{" "}
                                                    {changed ? (
                                                        <>
                                                            <span style={{ color: "red", textDecoration: "line-through", marginRight: "5px" }}>
                                                                {formatValue(f.oldValue)}
                                                            </span>
                                                            <span style={{ marginRight: "5px" }}>⇒</span>
                                                            <span style={{ color: "green", fontWeight: "bold" }}>
                                                                {formatValue(f.newValue)}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <span>{formatValue(f.oldValue)}</span>
                                                    )}
                                                </p>
                                            );
                                        });
                                    })()}

                                    <div className="mt-4 pt-3 border-top">
                                        <p>
                                            <strong>Requested On:</strong>{" "}
                                            {new Date(selectedRequest.requestTime).toLocaleString()}
                                        </p>

                                        <div className="mt-3">
                                            <label><strong>Comment (optional):</strong></label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                value={rejectionReason}
                                                onChange={(e) => setRejectionReason(e.target.value)}
                                                placeholder="Write your reason here..."
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    {selectedRequest?.type === 'requestHistoryLeave' ? (
                        <>
                            <Button
                                variant="danger"
                                className={`btn_sm ${styles.modalcancelRequestButton}`}
                                onClick={async () => {
                                    await handleCancelRequest(selectedRequest);
                                }}
                                disabled={loading}
                            >
                                {processingAction === 'cancel' ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                        Cancelling...
                                    </>
                                ) : "Cancel Request"}
                            </Button>
                            <Button variant="secondary" onClick={handleViewClose} disabled={loading}>
                                Close
                            </Button>
                        </>
                    ) : selectedRequest?.type === 'requestHistoryAdmin' ? (
                        <Button variant="secondary" onClick={handleViewClose} disabled={loading}>
                            Close
                        </Button>
                    ) : selectedRequest?.type === 'timeOff' ? (
                        <>
                            <Button
                                variant="success"
                                onClick={async () => {
                                    const isConfirmed = await showConfirmationDialog(
                                        "Are you sure?",
                                        "You are about to approve this leave request."
                                    );
                                    if (isConfirmed) {
                                        await handleApprove(selectedRequest.id);
                                        // Note: We don't manually close/Swal here because handleApprove handles the success logic now
                                    }
                                }}
                                className={`${styles.modalButton} ${styles.modalButtonApprove}`}
                                disabled={loading}
                            >
                                {processingAction === 'approve_timeoff' ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                        Approving...
                                    </>
                                ) : "Approve"}
                            </Button>
                            <Button
                                variant="danger"
                                onClick={() => {
                                    setViewModalOpen(false);
                                    handleRejectClick(selectedRequest.id);
                                }}
                                className={`${styles.modalButton} ${styles.modalButtonReject}`}
                                disabled={loading}
                            >
                                Reject
                            </Button>
                        </>
                    ) : selectedRequest?.type === 'adminTaskRequest' ? (
                        <>
                            <Button
                                variant="success"
                                onClick={() => handleAdminRequestApprove(selectedRequest.id)}
                                className={`${styles.modalButton} ${styles.modalButtonApprove}`}
                                disabled={loading || selectedRequest.status?.toLowerCase() !== "pending"}
                            >
                                {processingAction === 'approve_admin' ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                        Approving...
                                    </>
                                ) : "Approve"}
                            </Button>
                            <Button
                                variant="danger"
                                onClick={() => handleAdminRequestReject(selectedRequest.id)}
                                className={`${styles.modalButton} ${styles.modalButtonReject}`}
                                disabled={loading || selectedRequest.status?.toLowerCase() !== "pending"}
                            >
                                {processingAction === 'reject_admin' ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                        Rejecting...
                                    </>
                                ) : "Reject"}
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                variant="success"
                                onClick={() => handleProfileApprove(selectedRequest)}
                                className={`${styles.modalButton} ${styles.modalButtonApprove}`}
                                disabled={loading}
                            >
                                {processingAction === 'approve_profile' ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                        Approving...
                                    </>
                                ) : "Approve"}
                            </Button>
                            <Button
                                variant="danger"
                                onClick={() => handleProfileRejectConfirm(selectedRequest)}
                                className={`${styles.modalButton} ${styles.modalButtonReject}`}
                                disabled={loading}
                            >
                                {processingAction === 'reject_profile' ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                        Rejecting...
                                    </>
                                ) : "Reject"}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            {/* New Admin Request Modal */}
            {showNewRequestModal && <AdminRequestModal
                show={showNewRequestModal}
                handleClose={handleCloseNewRequestModal}
                onTaskSelected={handleTaskSelected}
            />}
            {/* <NewAdminRequestModal show={showNewRequestModal} handleClose={handleCloseNewRequestModal} /> */}

            {/* Task Closure Modal */}
            {selectedTaskId && (
                <RequestTaskClosureModal
                    show={showTaskClosureModal}
                    onHide={handleCloseTaskClosureModal}
                    taskId={selectedTaskId}
                    onSuccess={() => {
                        handleCloseTaskClosureModal();
                        fetchData();
                    }}
                />
            )}

            {/* Task Extension Modal */}
            {selectedTaskId && (
                <RequestTaskExtensionModal
                    show={showTaskExtensionModal}
                    onHide={handleCloseTaskExtensionModal}
                    taskId={selectedTaskId}
                    onSuccess={() => {
                        handleCloseTaskExtensionModal();
                        fetchData();
                    }}
                />
            )}
        </>
    )
}

export default AdminRequestsPanel